import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Transition } from "@headlessui/react";
import Layout from "../../../components/layout/Layout";
import PhotoGallery from "../../../components/PhotoGrid";
import FallBackPhotosIllustration from "../../../assets/icons/photos-empty-state-illustration.svg";
import { useProductPhotosContext } from "../../../utils/Contexts/V2/ProductPhotosContext";
import PhotoDeleteConfirmation from "../../../components/V2/PhotoDeleteConfirmation";
import PhotoOption from "../../../components/V2/PhotoOption";

function Products() {
  const {
    productPhotos,
    showDeleteConfirmation,
    isLoadingPhotos,
    setPage,
    setSearchTerm,
    searchTerm,
  } = useProductPhotosContext();
  const [clickedPhoto, setClickedPhoto] = useState();
  const [showPhotoOption, setShowPhotoOption] = useState(false);

  return (
    <Layout header headerTitle="Products">
      <div className="w-full lg:max-w-screen-md h-screen mx-auto flex flex-col items-center justify-between pb-20 pt-16 px-4">
        <Transition
          className="fixed -bottom-12 left-0 z-20 w-full"
          show={showDeleteConfirmation}
          enterFrom=" translate-y-0"
          enterTo=" -translate-y-12"
          leaveFrom=" -translate-y-12"
          leaveTo=" translate-y-0"
        >
          <PhotoDeleteConfirmation photo={clickedPhoto} />
        </Transition>
        <Transition
          className="fixed -bottom-12 left-0 z-20 w-full"
          show={showPhotoOption}
          enterFrom=" translate-y-0"
          enterTo=" -translate-y-12"
          leaveFrom=" -translate-y-12"
          leaveTo=" translate-y-0"
        >
          <PhotoOption
            photo={clickedPhoto}
            showPhotoOptionHandler={setShowPhotoOption}
          />
        </Transition>
        <div className="w-full my-10 flex flex-col justify-start items-start space-y-4">
          <div className="flex flex-row justify-between items-center border border-solid rounded-lg px-3 py-1 mb-10 w-full">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.3335 0.333252C9.6455 0.333252 12.3335 3.02125 12.3335 6.33325C12.3335 9.64525 9.6455 12.3333 6.3335 12.3333C3.0215 12.3333 0.333496 9.64525 0.333496 6.33325C0.333496 3.02125 3.0215 0.333252 6.3335 0.333252ZM6.3335 10.9999C8.9115 10.9999 11.0002 8.91125 11.0002 6.33325C11.0002 3.75459 8.9115 1.66659 6.3335 1.66659C3.75483 1.66659 1.66683 3.75459 1.66683 6.33325C1.66683 8.91125 3.75483 10.9999 6.3335 10.9999ZM11.9902 11.0473L13.8762 12.9326L12.9328 13.8759L11.0475 11.9899L11.9902 11.0473Z"
                fill="#808A93"
              />
            </svg>
            <input
              className="h-full w-full ml-2 py-2 text-xs outline-none"
              placeholder="Search"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* eslint-disable-next-line no-nested-ternary */}
          {productPhotos?.items?.length ? (
            <div className="w-full pb-12">
              <p className="font-bold text-sm mb-3">
                Showing {productPhotos?.items?.length} of {productPhotos?.total}
              </p>
              <PhotoGallery
                productPhotos={productPhotos.items}
                photo={setClickedPhoto}
                open={setShowPhotoOption}
              />
              {productPhotos?.items?.length < productPhotos?.total && (
                <button
                  type="button"
                  onClick={() => setPage((prev) => prev + 1)}
                  className="px-6 py-3 bg-primary-50 thryve:text-base font-bold text-sm text-white rounded-2xl w-full mt-6"
                >
                  {isLoadingPhotos ? "Loading..." : "Load More"}
                </button>
              )}
            </div>
          ) : searchTerm?.length > 3 && productPhotos?.items?.length === 0 ? (
            <div className="w-full mt-4 px-4 flex flex-col space-y-2 items-center">
              <img src={FallBackPhotosIllustration} alt="no photos" />
              <p className="font-normal text-sm text-center pt-10 w-[15rem]">
                No results found for {searchTerm}. Try a different search term.
              </p>
            </div>
          ) : (
            <div className="w-full mt-4 px-4 flex flex-col space-y-2 items-center">
              <img src={FallBackPhotosIllustration} alt="no photos" />
              <p className="font-normal text-sm text-center ">
                These photos are directly uploaded to your business webpage, so
                have some fun!
              </p>
              <NavLink
                to="/add-photos"
                className="px-6 py-3 bg-primary-50 thryve:text-base text-center font-medium text-sm text-white rounded-2xl w-full"
              >
                Upload a Photo
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default Products;
